import { render } from 'preact';
import { Boot } from '@shell/Boot';
import { ErrorBoundary } from '@shell/ErrorBoundary';
import { BootError } from '@shell/screens/BootError';
import { listenForInstallPrompt } from '@platform/install';
import { listenForConnectivityChange } from '@platform/offline-availability';
import { registerServiceWorker } from '@platform/pwa';
import '@/styles/index.css';

const root = document.getElementById('app');
if (!root) throw new Error('#app not found in index.html');

render(
  <ErrorBoundary fallback={() => <BootError />}>
    <Boot />
  </ErrorBoundary>,
  root,
);

// PWA-004: registers on load, after render so a registration failure
// (PWA-005) has nothing on the render path to disturb -- see pwa.ts's own
// header for why that failure mode cannot actually reach this far anyway.
registerServiceWorker();
listenForInstallPrompt();
listenForConnectivityChange();
